import React from 'react';
import SettingsIcon from '@material-ui/icons/Settings';
import { Storage } from 'aws-amplify';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectInput,
} from 'candy-commons-components';
import {
    ArrayInput,
    Create,
    FileField,
    FileInput,
    SimpleForm,
    SimpleFormIterator,
    TextInput,
    required,
} from 'react-admin';
import languages from '../../data/languages.json';
import { useSelector } from 'react-redux';
import {
    getApplianceTypes,
    getBrands,
    getSeries,
} from '../../selectors/cmsConfig';
const breadcrumbsData = [
    {
        text: 'Video Tutorials',
        url: 'video-tutorial',
        icon: <SettingsIcon />,
    },
    {
        text: 'Create',
        url: '',
    },
];

const VideoTutorialCreate = (props) => {
    const applianceTypes = useSelector(getApplianceTypes);
    const brands = useSelector(getBrands);
    const series = useSelector(getSeries);
    const handleClick = async (event) => {
        const file = event;
        if (!file) {
            return;
        }
        const key = `videoTutorial/${file.name}`;
        const upload = await Storage.put(key, file, {
            contentType: file.type,
        });
    };
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Create {...props}>
                <SimpleForm>
                    <ContainerFieldsList>
                        {/*Appliance type*/}
                        <CustomSelectInput
                            source="applianceType"
                            choices={applianceTypes}
                            validate={[required()]}
                        />
                        {/*Brand*/}
                        <CustomSelectInput source="brand" choices={brands} />
                        <CustomSelectInput source="series" choices={series} />
                        <TextInput
                            source="link"
                            label="Link"
                            validate={[required()]}
                        />
                        <TextInput
                            source="title"
                            label="Title"
                            validate={[required()]}
                        />
                        <FileInput
                            source="photo"
                            label="photo(jpeg, 152x107)"
                            accept="image/x-png,image/gif,image/jpeg"
                            onChange={handleClick}
                            validate={[required()]}
                        >
                            <FileField source="src" title="title" />
                        </FileInput>
                        {/*Languages*/}
                        <ArrayInput source="language" validate={[required()]}>
                            <SimpleFormIterator disableRemove>
                                <CustomSelectInput
                                    choices={languages}
                                    validate={[required()]}
                                />
                            </SimpleFormIterator>
                        </ArrayInput>
                    </ContainerFieldsList>
                </SimpleForm>
            </Create>
        </>
    );
};
export default VideoTutorialCreate;
